<template>
    <div class="wlx-user-manager-wrapper">
        <div class="add-partner-enterprise-head clearfix">
            <div class="top-page-top fl">
                <span class="sp-top-text">用户管理</span>
            </div>
            <div class="fr btn-right">
                <el-form :inline="true" size="small">
                    <el-form-item>
                        <el-input v-model="userName" placeholder="请输入用户账号" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="displayName" placeholder="请输入用户姓名" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" @click="getAllUserList()">搜索</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <el-table :data="siteList">
            <el-table-column label="序号" type="index" width="50"></el-table-column>
            <el-table-column prop="userName" label="账号"></el-table-column>
            <el-table-column prop="displayName" label="姓名"></el-table-column>
            <!-- <el-table-column prop="sex" label="性别">
            <template slot-scope="scope">
             <span v-if="scope.row.sex == 0">男</span>
             <span v-if="scope.row.sex == 1">女</span>
             </template>
          </el-table-column> -->
            <el-table-column prop="phone" label="手机号" v-if="userInfo.isSys"></el-table-column>
            <el-table-column prop="schoolName" label="单位"></el-table-column>
            <el-table-column prop="dateCreated" label="创建时间"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="重置密码" placement="top">
                        <el-button icon="el-icon-refresh" size="mini" type="primary" @click="newPasswords(scope.row)"></el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="删除" placement="top">
                        <el-button icon="el-icon-delete" size="mini" type="danger" @click="deleteUser(scope.row.id)"></el-button>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>

        <div class="u-page-con">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="onPageChangeHandler"
                :current-page="page"
                :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
                v-show="totalCount > 0"
                style="text-align: center;"
            ></el-pagination>
        </div>

        <el-dialog title="修改密码" :visible.sync="dialogVisible" append-to-body width="30%">
            <span style="color: red;font-size: 15px;">默认账号后六位</span>
            <div>
                <el-input v-model="newPassword" placeholder="请输入新密码" clearable></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="newPasswords()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            page: 1,
            pageSize: 10,
            totalCount: 0,
            siteList: [],
            dialogVisible: false,
            userName: "",
            displayName: "",
            newPassword: "",
            id: "",
            schoolId: "",
            schoolInfo: [],
        };
    },
    components: {

    },
    computed: {
        userInfo() {
            return this.$store.state.auth;
        }
    },
    created() {
        this.getSchoolInfo();
        this.getAllUserList();
    },
    methods: {
        //  goLook(row) {
        //   this.id = row.id;
        //   this.dialogVisible = true;

        // },
        //获取单位列表
        getSchoolInfo() {
            var that = this;
            this.$http.post("/api/XOrg/XLogin/getSchoolInfo").then(function(rst) {
                if (rst.code > 0) {
                    that.schoolInfo = rst.schoolInfo;
                }
            });
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getAllUserList();
        },
        onPageChangeHandler(val) {
            this.page = val;
            this.getAllUserList();
        },
        newPasswords(row) {
            this.newPassword = row.phone.substring(row.phone.length - 6, row.phone.length);
            var that = this;

             this.$confirm("此操作将重置密码为手机号后6位, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
            .then(() => {
                this.$http
                .post("/api/XOrg/AssessmentApply/updatePassWord", {
                    id: row.id,
                    newPassword: that.newPassword,
                    PageSize: that.pageSize,
                    page: that.page,
                })
                .then((rst) => {
                    if (rst.code > 0) {
                        this.$message.success(rst.msg);
                        this.dialogVisible = false;
                    } else {
                        this.$message.warning(rst.msg);
                    }
                });
            })
            .catch(() => {
                this.$message({
                    type: "info",
                    message: "已取消重置",
                });
            });

           
        },
        deleteUser(id) {
            this.$confirm("此操作将删除该用户, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$http
                        .post("/api/XOrg/AssessmentApply/deleteUser", {
                            id: id,
                        })
                        .then((rst) => {
                            if (rst.code > 0) {
                                this.$message.success(rst.msg);
                                this.getAllUserList();
                            } else {
                                this.$message.warning(rst.msg);
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        getAllUserList() {
            var that = this;
            this.$http
                .post("/api/XOrg/AssessmentApply/getAllUserList", {
                    schoolId: this.schoolId,
                    userName: that.userName,
                    displayName: that.displayName,
                    PageSize: that.pageSize,
                    page: that.page,
                })
                .then((rst) => {
                    that.siteList = rst.list;
                    that.page = rst.pagination.pageIndex;
                    that.pageSize = rst.pagination.pageSize;
                    that.totalCount = rst.pagination.totalCount;
                });
        },
    },
};
</script>
<style lang="scss">
.wlx-user-manager-wrapper {
    background: #fff;
    padding-bottom: 20px;
    .add-partner-enterprise-head {
        border-bottom: 1px solid #F0F0F0;
        height: 60px;
        .add-banner-btn,
        .delete-banner-btn {
            margin-top: 13px;
        }
        .delete-banner-btn {
            margin-right: 62px;
        }
        .top-page-top{
            border: none;
        }
    }
    .banner-page-con {
        padding: 20px 0;
        text-align: center;
    }
    .el-table thead{
        color: #05243D;
    }
    .btn-right{
        margin-right: 30px;
        margin-top: 14px;
    }
}
</style>
